import React from 'react';

import {Trans, useTranslation} from 'react-i18next';
import {
    FontVariant,
    TextHeading,
    Text,
    Form,
    Bar,
    Button,
} from '@pexip/components';
import {TestId} from '../../../test/testIds';

export const TurnOnNotifications: React.FC<{
    onSubmit: () => void;
    onSkip?: () => void;
}> = ({onSubmit, onSkip}) => {
    const {t} = useTranslation();

    return (
        <>
            <TextHeading
                htmlTag="h2"
                fontVariant={FontVariant.H2}
                className="mb-2"
            >
                <Trans t={t} i18nKey="notifications.title">
                    Turn on notifications to receive incoming calls
                </Trans>
            </TextHeading>
            <Text>
                <Trans t={t} i18nKey="notifications.description">
                    Please select <strong>“Allow”</strong> in the next step when
                    prompted by your browser. We will only have access during
                    the duration of the meeting.
                </Trans>
            </Text>
            <Form
                onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
                    event.preventDefault();
                    onSubmit();
                }}
            >
                <Bar>
                    <Button
                        modifier="fullWidth"
                        type="submit"
                        size="large"
                        data-testid={TestId.ButtonTurnOnNotifications}
                        className="mt-5 mb-3"
                    >
                        <Trans t={t} i18nKey="notifications.turn-on-button">
                            Turn on notifications
                        </Trans>
                    </Button>
                </Bar>
                {onSkip && (
                    <Bar>
                        <Button
                            modifier="fullWidth"
                            variant="tertiary"
                            size="large"
                            onClick={onSkip}
                            data-testid={TestId.ButtonSkipNotifications}
                        >
                            <Trans t={t} i18nKey="notifications.skip">
                                Skip
                            </Trans>
                        </Button>
                    </Bar>
                )}
            </Form>
        </>
    );
};
